// extracted by mini-css-extract-plugin
export default {"gridProductList":"GridProductList_gridProductList__UsLz-"};